import { FC } from 'react'
import styled, { css } from 'styled-components'
import Chip from '../Chip'
import ResetButton from './ResetButton'

export type TSelectedFilterItem = {
  id: string
  name: string
  label: string
  order?: number
}

interface IFSelectedFilterListProps {
  items: TSelectedFilterItem[]
  onRemove: (item: TSelectedFilterItem) => void
  onReset: () => void
  className?: string
}

const SelectedFilterList: FC<IFSelectedFilterListProps> = ({
  items,
  onRemove,
  onReset,
  className,
}) => {
  return (
    <StyledWrapper className={className}>
      <ResetButton onClick={onReset} className="reset-button" />
      <div className="chip-wrapper">
        {items.map((item) => (
          <StyledChip
            key={`${item.name}-${item.id}`}
            label={item.label}
            order={item?.order}
            onClick={() => {
              onRemove(item)
            }}
          />
        ))}
      </div>
    </StyledWrapper>
  )
}

export default SelectedFilterList

const StyledWrapper = styled.div`
  display: flex;

  .reset-button {
    margin-right: 5px;
    flex-shrink: 0;
  }

  .chip-wrapper {
    display: flex;
    gap: 5px;
    overflow-x: auto;
    /* 스크롤바 제거 */
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`

interface IFStyledChipProps {
  order?: number
}

const StyledChip = styled(Chip)<IFStyledChipProps>`
  ${({ order }) => css`
    order: -${order || 0};
    white-space: nowrap;
  `}
`
